declare global {
  interface ImportMetaEnv {
    VITE_SITE_URL: string;
  }
}

const SITE_URL: string = import.meta.env.VITE_SITE_URL;

const FAVICON_URL = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/62f99c0415358bd5388d5ed1df9ac1ff.jpeg';

export interface ArticleJsonLdInput {
  headline: string;
  description: string;
  image: string;
  datePublished?: string;
  dateModified?: string;
  authorName?: string;
  url: string;
}

export interface FaqJsonLdInput {
  question: string;
  answer: string;
}

export interface BreadcrumbItem {
  name: string;
  url: string;
}

export function buildOrganizationJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Itaobuy Spreadsheet Italia',
    url: SITE_URL,
    logo: FAVICON_URL,
  };
}

export function buildWebSiteJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Itaobuy Spreadsheet Italia',
    url: SITE_URL,
    description: 'La guida italiana piu completa su Itaobuy Spreadsheet: tutorial, liste prodotti, sicurezza e consigli per acquistare meglio online.',
    inLanguage: 'it-IT',
    publisher: {
      '@type': 'Organization',
      name: 'Itaobuy Spreadsheet Italia',
    },
  };
}

export function buildArticleJsonLd(input: ArticleJsonLdInput) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: input.headline,
    description: input.description,
    image: input.image,
    author: {
      '@type': 'Person',
      name: input.authorName || 'Team Itaobuy Sheet',
    },
    datePublished: input.datePublished || '2026-07-14',
    dateModified: input.dateModified || '2026-07-14',
    inLanguage: 'it-IT',
    publisher: {
      '@type': 'Organization',
      name: 'Itaobuy Spreadsheet Italia',
      logo: {
        '@type': 'ImageObject',
        url: FAVICON_URL,
      },
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': input.url,
    },
  };
}

export function buildFaqPageJsonLd(faqs: FaqJsonLdInput[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
}

export function buildBreadcrumbJsonLd(items: BreadcrumbItem[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, idx) => ({
      '@type': 'ListItem',
      position: idx + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

export { SITE_URL, FAVICON_URL };